const LINK_HELP_LIMITS_ABOVE_50 = 'https://ajuda.melhorenvio.com.br/pt-BR/articles/4381808-posso-ter-um-limite-de-etiquetas-simultaneas-maior-que-50';

const MODAL_CONFIG = {
  NON_VERIFIED: {
    ICON: '/images/svg-symbols.svg#stamp-non_verified',
    TITLE: 'Verifique sua conta',
    BODY: `
    Com uma conta verificada você aumenta seu limite para até
    50 envios por vez. 100% online, seguro e sem custo algum.
    `,
    BUTTON: 'verifique sua conta',
    LINK: '/painel/gerenciar/documentos'
  },

  VERIFIED: {
    ICON: '/images/svg-symbols.svg#stamp-totally_verified',
    TITLE: 'Sua conta está verificada!',
    BODY: `
    Seu limite de envios vai aumentar de acordo com
    a quantidade de postagens que você fizer, podendo
    chegar a 50 envios simultâneos.
    `,
    BUTTON: 'saiba mais',
    LINK: LINK_HELP_LIMITS_ABOVE_50
  }
};

export default {
  data() {
    return {userStatus: ''};
  },

  computed: {

    /**
     * Checks if the user is verified or not
     * @returns {boolean}
     */
    isVerified() {
      return this.userStatus === 'VERIFIED';
    },

    /**
     * Builds the icon size style
     * @returns {string}
     */
    iconSize() {
      return `
        width: 40px;
        height: 40px;
      `;
    }
  },

	methods: {

    /**
     * Gets the modal config based on the user status and
     * the object parameter wanted
     * @param {string} parameter
     * @returns {string}
     */
    getModalConfig(parameter) {
      if (this.isVerified) {
        return MODAL_CONFIG.VERIFIED[parameter];
      }

      return MODAL_CONFIG.NON_VERIFIED[parameter];
    },

    redirectToLink() {
      if(this.isVerified) {
        window.open(this.getModalConfig('LINK'), '_blank');

        return;
      }

      window.open(this.getModalConfig('LINK'), '_self');
    }
  }
};
